import React from 'react';
import moment from 'moment';
import { Box, Modal } from '@material-ui/core';
import View from './View';

export const orderColumn = [
  {
    Header: 'Username',
    accessor: '',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { user } = payload;
      return <>{user && user[0] && user[0].name}</>;
    },
  },
  { Header: 'Order Id', accessor: 'orderId' },
  {
    Header: 'Total Price',
    accessor: 'total',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { total, metadata } = payload;
      return (
        <>
          {total}-{metadata && metadata.currency}
        </>
      );
    },
  },
  { Header: 'Discount', accessor: 'offer' },
  { Header: 'Status', accessor: 'status' },
  {
    Header: 'Created At',
    accessor: 'createdAt',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { createdAt } = payload;
      return <>{moment(createdAt).format('MMMM Do, YYYY')}</>;
    },
  },
  {
    Header: 'Updated At',
    accessor: 'updatedAt',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { updatedAt } = payload;
      return <>{moment(updatedAt).format('MMMM Do, YYYY')}</>;
    },
  },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const [open, setOpen] = React.useState(false);
      const handleOpen = () => setOpen(true);
      const handleClose = () => setOpen(false);
      return (
        <Box>
          <Box
            onClick={handleOpen}
            sx={{ cursor: 'pointer', textDecoration: 'underline' }}>
            View Details
          </Box>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <>
              <View details={payload} />
            </>
          </Modal>
        </Box>
      );
    },
  },
];
